"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const navigation_html_1 = require("./navigation.html");
const d3_1 = require("d3");
const d3_hypertree_1 = require("d3-hypertree");
const d3_hypertree_2 = require("d3-hypertree");
const splitter_1 = require("../splitter/splitter");
const primitive_1 = require("../primitive");
const icons_1 = require("../../models/icons/icons");
class Navigation //implements Controller<NavigationArgs, HTMLElement>
 {
    constructor(view, model) {
        this.iconmap = new icons_1.Icons();
        //private on Page shange
        this.golast = () => {
            if (this.view.hypertree.isAnimationRunning())
                return;
            //console.error('Going to /')
            gtag('config', 'UA-124333733-1', {
                'page_title': '/',
                'page_path': '/'
            });
            this.model.last();
            this.updatecurrent();
        };
        this.goidx = idx => () => {
            this.model.setidx(idx);
            this.updatecurrent();
        };
        this.next = Δ => () => {
            this.model.next(Δ);
            this.updatecurrent();
        };
        this.updatecurrent = () => {
            // hypertreemodel is egentlich nur das diff
            // das ganz hat nur this.view.hypertree.args
            const hypertreemodel = this.model.currentdemo.hypertreeModel;
            hypertreemodel.dataInitBFS = this.model.currentdemo.nodeInit;
            hypertreemodel.interaction = hypertreemodel.interaction || {};
            hypertreemodel.interaction.onNodeSelect = this.updateFocusView;
            hypertreemodel.interaction.onCenterNodeChange = (n, s) => {
                this.view.ui.breadcrumb2.innerText = s;
            };
            hypertreemodel.interaction.onNodeClick = (n, m, l) => {
                if (this.model.islast() && n && n.data) {
                    //console.error('Going to ', n.data.name)
                    gtag('config', 'UA-124333733-1', {
                        'page_title': n.data.name,
                        'page_path': '/' + n.data.name
                    });
                    this.goidx(n.data.idx)();
                }
                else if (n.mergeId !== l.view.unitdisk.args.transformation.cache.centerNode.mergeId) {
                    //console.error('What is this?', n.data.name)
                    //console.log('not same --> goto node')
                    l.view.hypertree.api.goto(d3_hypertree_2.CmulR({ re: n.layout.z.re, im: n.layout.z.im }, -1), null)
                        .then(() => l.view.hypertree.drawDetailFrame());
                }
            };
            hypertreemodel.dataloader = this.model.currentdemo.loader;
            hypertreemodel.langloader = this.model.currentdemo.langloader(this.model.currentlang);
            const setModelPromise = this.view.hypertree.api.setModel(hypertreemodel);
            if (this.model.islast())
                setModelPromise
                    .then(() => new Promise((ok, err) => this.view.hypertree.animateUp(ok, err)))
                    .then(() => this.view.hypertree.api.goto({ re: .25, im: .24 }, null))
                    .then(() => this.view.hypertree.drawDetailFrame());
            else
                setModelPromise
                    .then(() => new Promise((ok, err) => this.view.hypertree.animateUp(ok, err)))
                    .then(() => this.view.hypertree.api.goto({ re: 0, im: .34 }, null))
                    .then(() => this.view.hypertree.api.gotoλ(.17))
                    .then(() => this.view.hypertree.drawDetailFrame());
            this.view.ui.updateLangs(this.model.currentdemo.languages);
            this.updateFocusView();
            this.updateBreadcrumbView(this.model.currentdemo.path);
        };
        this.updateLang = (langId, lang) => {
            this.model.currentlang = langId;
            const newlangloader = this.model.currentdemo.langloader(this.model.currentlang);
            this.view.hypertree.api.setLangloader(() => { }, () => { }, newlangloader);
            document.body.lang = this.model.currentlang;
            this.updateFocusView();
        };
        this.updateFocusView = (n) => {
            /*
            if (!n) {
                
            }
            else if (this.view.hypertree.args.objects.selections.length > 0) {*/
            this.updateAutoView(n);
            //this.view.stringUi.enableResizeListener(false)          
            this.view.splitter.setSizes(this.model.splitterProportion, () => { } //this.view.stringUi.enableResizeListener(true)
            );
            /*}
            else {
                this.view.splitter.setSizes(this.model.splitterProportion, ()=> {})
    
                this.view.stringUi.ui.style.display = 'inherit'
                this.view.wiki.ui.style.display     = 'none'
            }*/
        };
        this.view = view;
        this.model = model;
        this.view.ui = navigation_html_1.NavigationHTML({
            parent: this.view.parent,
            onNextClick: this.next(+1),
            onPrevClick: this.next(-1),
            onLangChange: this.updateLang,
            onQuery: queryStr => this.view.hypertree.api.selectQuery(queryStr, undefined)
            //onCssChange:    this.updateCss
        });
        this.view.splitter = new splitter_1.Splitter({
            parent: this.view.ui.content,
            splitterProportion: this.model.splitterProportion[0],
            onDragStart: () => this.view.stringUi.enableResizeListener(false),
            onDragEnd: () => {
                this.model.splitterProportion = this.view.splitter.getSizes();
                this.view.stringUi.enableResizeListener(true);
            },
        });
        this.view.wiki = new primitive_1.WikiUi({
            parent: this.view.splitter.ui.right,
            visible: false
        });
        this.view.stringUi = new primitive_1.StringUi({
            parent: this.view.splitter.ui.right,
            visible: false
        });
        const hypertreemodel = this.model.currentdemo.hypertreeModel;
        hypertreemodel.dataInitBFS = this.model.currentdemo.nodeInit;
        hypertreemodel.interaction = hypertreemodel.interaction || {};
        hypertreemodel.interaction.onNodeClick = (n, m, l) => {
            if (this.model.islast() && n && n.data) {
                this.goidx(n.data.idx)();
                console.log('##########', n.data.name, n);
                //console.error('Going to ', n.data.name)
                gtag('config', 'UA-124333733-1', {
                    'page_title': n.data.name,
                    'page_path': '/' + n.data.name
                });
            }
            else if (n.mergeId !== l.view.unitdisk.args.transformation.cache.centerNode.mergeId) {
                //console.log('not same --> goto node')
                /*
                gtag('config', 'UA-124333733-1', {
                    'page_title' : 'homepage',
                    'page_path': '/home'
                })*/
                l.view.hypertree.api.goto(d3_hypertree_2.CmulR({ re: n.layout.z.re, im: n.layout.z.im }, -1), null)
                    .then(() => l.view.hypertree.drawDetailFrame());
            }
        };
        hypertreemodel.interaction.onNodeSelect = (n) => {
            this.updateFocusView(n);
            /*
            if (this.model.islast() && n && n.data) {
                this.goidx(n.data.idx)()
            }*/
        };
        hypertreemodel.dataloader = this.model.currentdemo.loader;
        hypertreemodel.langloader = this.model.currentdemo.langloader(this.model.currentlang);
        hypertreemodel.interaction.onCenterNodeChange = (n, s) => {
            this.view.ui.breadcrumb2.innerText = s;
        };
        this.view.hypertree = new d3_hypertree_1.HypertreeEx({ parent: this.view.splitter.ui.left }, hypertreemodel);
        this.view.hypertree.initPromise
            .then(() => new Promise((ok, err) => this.view.hypertree.animateUp(ok, err)))
            .then(() => this.view.hypertree.api.goto({ re: .25, im: .24 }, null))
            //.then(()=> this.view.hypertree.api.goto({ re:  0, im: .5 }, null))
            //.then(()=> this.view.hypertree.api.gotoλ(.15))  
            .then(() => this.view.hypertree.drawDetailFrame());
        /*.then(()=> this.view.hypertree.api.goto({ re: -.6, im: .6 }, null))
        .then(()=> this.view.hypertree.api.goto({ re: -.738, im: .36 }, null))
        .then(()=> this.view.hypertree.api.gotoλ(.3))
        .then(()=> this.view.hypertree.api.gotoλ(.2))
        .then(()=> this.view.hypertree.api.goto({ re: -.25, im: .14 }, null))
        .then(()=> this.view.hypertree.drawDetailFrame())*/
        this.view.ui.updateLangs(this.model.currentdemo.languages);
        this.updateFocusView();
        this.updateBreadcrumbView(this.model.currentdemo.path);
    }
    //### internal
    updateAutoView(n) {
        if (!n) {
            this.view.stringUi.ui.style.display = 'none';
            this.view.wiki.ui.style.display = 'none';
            return;
        }
        const articleNode = n ? n : this.view.hypertree.args.objects.selections.slice(-1)[0];
        const isFile = articleNode.data.type == 'file'
            || articleNode.data.type == 'dir';
        //console.log('Splitter: updateAutoView', n, isFile)
        if (isFile) // MONACO
         {
            this.view.stringUi.ui.style.display = 'inherit';
            this.view.wiki.ui.style.display = 'none';
            //this.view.stringUi.editor.setValue(getstr(this.view.hypertree, articleNode))
        }
        else // WIKI
         {
            this.view.stringUi.ui.style.display = 'none';
            this.view.wiki.ui.style.display = 'inherit';
            //console.log("Updateing Wiki: ", articleNode.data.name)
            const newSrc = `https://${this.model.currentlang}.m.wikipedia.org/wiki/${articleNode.data.name}`;
            if (this.view.wiki && newSrc !== this.view.wiki.ui.src)
                this.view.wiki.ui.src = newSrc;
        }
    }
    updateBreadcrumbView(path) {
        this.view.ui.breadcrumb.innerHTML = '';
        d3_1.select(this.view.ui.breadcrumb)
            .selectAll('a')
            .data(path)
            .enter().append('a')
            .classed('breadcrumb', true)
            .text(d => d.split('-').join(' '));
    }
}
exports.Navigation = Navigation;
function getstr(hypertree, articleNode) {
    const nodeModelStr = JSON.stringify(articleNode, (key, value) => (key === 'parent'
        || key === 'children'
        || key === 'head'
        || key === 'ancestors')
        ? ` ==>N? ${value && value.length}`
        : value, 4);
    const treeModelStr = JSON.stringify(hypertree.args, (key, value) => (key === 'parent'
        || key === 'children'
        || key === 'head'
        || key === 'ancestors'
        || key === 'selections'
        || key === 'iconmap'
        || key === 'centerNode'
        || key === 'unculledNodes'
        || key === 'links'
        || key === 'leafOrLazy'
        || key === 'spezialNodes'
        || key === 'paths'
        || key === 'weights'
        || key === 'labels'
        || key === 'emojis'
        || key === 'images'
        || key === 'voronoiDiagram'
        || key === 'cells'
        || key === 'P' || key === 'θ' || key === 'λ')
        ? ` ==>N? ${value && value.length}`
        : value, 4);
    return nodeModelStr + ',\n' + treeModelStr;
}
/*
'Hyperbolic Tree of Life' is a free interactive visualisation of the phylogenetic tree created by the 'Open Tree of Life' project. I hope you enjoy it!

>> https://hyperbolic-tree-of-life.github.io
Only desktops and tablets supported so far.
*/
/*
'Hyperbolic Tree of Life' ist eine interaktive Visualisierung des phylogenetischen Baums von 'Open Tree of Life'. Viel Spaß im virtuellen Tiergarten!

>> https://hyperbolic-tree-of-life.github.io
Leider vorerst nur für Desktops und Tablets.
*/ 



//////////////////
// WEBPACK FOOTER
// ./dist/js/components/navigation/navigation.js
// module id = 741
// module chunks = 0